import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/ _createTextVNode(" + ");
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.users.add_participant_slot')
};
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import DrawerEndingButton from '@/components/DrawerEndingButton.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'AddParticipantSlot',
    setup(__props) {
        const retroStore = useRetroStore();
        const { isInviteModalVisible } = storeToRefs(retroStore);
        function handleClick() {
            isInviteModalVisible.value = true;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DrawerEndingButton, { onClick: handleClick }, {
                circle: _withCtx(() => [
                    _hoisted_1
                ]),
                text: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('add')), 1)
                ]),
                _: 1
            }));
        };
    }
});
